import React from "react";
import { inject } from "mobx-react";
import CompilePrivate from "Texts/private";
// import { compilePrivatePart2 } from "Texts/private_part_2";
import { graphql } from "@apollo/client/react/hoc";
import { SITE_CONFIG_QUERY } from "Services/queries";
import { withRouter } from "react-router-dom";
import TextBlock from "ComponentsUI/TextBlock";
import Container from "reactstrap/lib/Container";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { BigBlockStub } from "Layouts/Stubs";
import { AggrementPdfFile } from "Constants/url";
import { isMoscowSiteCode, isPiterSiteCode, isMainSiteCode } from "Utils/siteConfig";

@inject("ApplicationModel")
class Page extends React.Component {
	componentDidMount() {
		let hash = this.props.location.hash;
		if (hash === "") {
			window.scrollTo(0, 0);
		} else {
			setTimeout(() => {
				const id = hash.replace("#", "");
				const element = document.getElementById(id);
				if (element) element.scrollIntoView();
			}, 0);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let hash = this.props.location.hash;
		let prevHash = prevProps.location.hash;
		if (prevHash !== hash) {
			if (hash === "") {
				window.scrollTo(0, 0);
			} else {
				setTimeout(() => {
					const id = hash.replace("#", "");
					const element = document.getElementById(id);
					if (element) element.scrollIntoView();
				}, 0);
			}
		}
	}

	handleClickDownloadUrl(elem) {
		fetch(elem.url).then((response) => {
			response.blob().then((blob) => {
				let url = window.URL.createObjectURL(blob);
				let a = document.createElement("a");
				a.href = url;
				a.download = `${elem.name}.pdf`;
				a.click();
			});
			//window.location.href = response.url;
		});
	}

	render() {
		let text = this.props.ApplicationModel.text;
		if (!this.props.data.siteConfig) return <BigBlockStub />;
		let siteConfig = this.props.data.siteConfig;
		const siteCode = this.props.ApplicationModel.siteCode;
		const sitePrefix = `http${siteConfig.ssl ? "s" : ""}://${
			isMoscowSiteCode(siteConfig.code) ? "www." : ""
		}`;

		let address = isMainSiteCode(siteConfig.code)
			? text.address_101internet
			: isMoscowSiteCode(siteConfig.code)
				? text.address_moskvaonline
				: isPiterSiteCode(siteConfig.code)
					? text.address_piteronline
					: "";

		let companyName = isMoscowSiteCode(siteConfig.code)
			? text.company_name_moskvaonline
			: isPiterSiteCode(siteConfig.code)
				? text.company_name_piteronline
				: isMainSiteCode(siteConfig.code)
					? text.company_name_101internet
					: "";

		// let processing = compilePrivatePart2(
		//     siteConfig.domain_name,
		//     sitePrefix,
		//     companyName,
		//     siteConfig.code
		// );

		let downloadArr = [
			{
				url: AggrementPdfFile[siteConfig.code].app1,
				name: text.application_personal_data_1,
			},
			{
				url: AggrementPdfFile[siteConfig.code].app2,
				name: text.application_personal_data_2,
			},
		];

		let downloadArrPart2 = [
			{
				url: AggrementPdfFile[siteConfig.code].processing,
				name: text.processing_personal_data,
			},
		];

		if (isMainSiteCode(siteConfig.code)) {
			downloadArrPart2.push({
				url: AggrementPdfFile[siteConfig.code].functional,
				name: text.functional_description,
			});
			downloadArrPart2.push({
				url: AggrementPdfFile[siteConfig.code].manual,
				name: text.manual,
			});
		}

		return (
			<Container>
				{isMainSiteCode(siteCode) && <div></div>}
				<PaddingBottom>
					<TextBlock
						text={
							<CompilePrivate
								domain={siteConfig.domain_name}
								location={this.props.location.pathname}
								shema={sitePrefix}
								company={companyName}
								address={address}
								siteCode101={isMainSiteCode(siteConfig.code)}
								download={downloadArr}
								downloadPart2={downloadArrPart2}
								handleClickDownloadUrl={this.handleClickDownloadUrl}
								otherInfoBoolean={isMainSiteCode(siteConfig.code)}
							/>
						}
						liStyleDisc={true}
						changeTable={true}
						siteCode={siteConfig.code}
						noDangerously={true}
					/>
				</PaddingBottom>
			</Container>
		);
	}
}

export default withRouter(graphql(SITE_CONFIG_QUERY)(Page));
